import ndsTokens from 'nicollet-tokens';

/* eslint-disable unicorn/filename-case */

const linkColors = ndsTokens.colors.link; // Color getters

const getColorPair = (color = 'onLight') => linkColors[color] || linkColors.onLight;

const getColor = color => getColorPair(color).default;

const getHoverColor = (color, noHoverColor) => noHoverColor ? getColorPair(color).default : getColorPair(color).hover; // Underline getters
// These take the underline policy prop as their only argument, and return the
// appropriate value of 'text-decoration'.


const getUnderline = u => u === 'default' || u === 'always' ? 'underline' : 'none';

const getHoverUnderline = u => u === 'default' || u === 'never' ? 'none' : 'underline'; // CSS text emitting functions
// For use in Styled Component blocks


const defaultStyles = ({
  color,
  underline
}) => {
  const colorValue = getColor(color);
  const underlineValue = getUnderline(underline);
  return `
    vertical-align: baseline;
    position: relative;
    cursor: pointer;
    color: ${colorValue};
    &:visited {
      color: ${colorValue};
    }
    text-decoration: ${underlineValue};
  `;
};
const hoverStyles = ({
  color,
  noHoverColor,
  underline
}) => `
  &:hover {
    color: ${getHoverColor(color, noHoverColor)};
    text-decoration: ${getHoverUnderline(underline)}
  }
`;
const focusStyleProperties = hoverColorValue => `
  color: ${hoverColorValue}; /* Focus text color matches hover text color */
  text-decoration: none;
  outline-style: dashed;
  outline-offset: 3px;
  outline-width: 1px;
  outline-color: ${hoverColorValue}; /* Outline matches hover text color */
`;
const focusStyles = ({
  color,
  noHoverColor
}) => {
  const hoverColorValue = getHoverColor(color, noHoverColor);
  return `
    &:focus {
      ${focusStyleProperties(hoverColorValue)}
    }
  `;
}; // override browser button styles

const buttonStyles = `
  vertical-align: middle;
  box-shadow: none;
  background-color: transparent;
  -webkit-tap-highlight-color: transparent;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  padding: 0;
  border-width: 0;
  border-style: initial;
  border-color: initial;
  border-image: initial;
  overflow: visible;
`;

export { buttonStyles, defaultStyles, focusStyleProperties, focusStyles, hoverStyles };
